module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.fails.js
 ** module id = 255
 ** module chunks = 0
 **/